<template>
  <li class="nav-item">
    <button
      class="nav-link"
      :class="{ active: value === modelValue }"
      @click="onChange(value)"
    >
      <slot></slot>
    </button>
  </li>
</template>

<script setup lang="ts">
import { useTabsContext } from "./UITabs.vue";

defineProps<{ value: string }>();
const { modelValue, onChange } = useTabsContext();
</script>
